import { ChangeScheduleRequestListComponent } from './list-req-ganti-jadwal.component';

export default ChangeScheduleRequestListComponent;
